import './404.css';
import notFoundImg from './404.gif';

export default function NoMatch() {
    return (
        <div className="wms-404-container">
            <img className="wms-404-logo" src={notFoundImg} alt="WMS 404 Logo" />
            <div className="wms-404-msg">Page not found</div>
        </div>);
}